<template>
    <div class="float-icon-wrap" id="floatBox">
        <div class="float-icon"></div>
        <div class="float-menus">
                <div class="items">
                    <div class="item tel" @click="toTel" >
                        <div class="icon"></div>
                        <div class="info">
                            <div class="label">{{floatInfo.tel.title}}</div>
                            <div class="value">{{floatInfo.tel.value}}</div>
                        </div>
                    </div>
                    <div class="item email" @click="toEmail" >
                        <div class="icon"></div>
                        <div class="info">
                            <div class="label">{{floatInfo.email.title}}</div>
                            <div class="value">{{floatInfo.email.value}}</div>
                        </div>
                    </div>
                    <div class="item msg" @click="toMsg" >
                        <div class="icon"></div>
                        <div class="info">
                            <div class="label">更多联系方式>></div> 
                        </div>
                    </div>
                </div>
            </div>
    </div>
</template>
<script>
import { Toast } from 'vant';

export default {
    data() {
        return {
            floatInfo: {
                tel: {
                    title: '咨询电话',
                    value: '400-993-0314'
                },
                email: {
                    title: '商务邮箱',
                    value: 'media@hudongpai.com'
                }
            }
        }
    },
    async created() {
        // 测试环境
        if (window.location.href.indexOf('localhost') >= 0) {
            var res = await this.$post('/test/getPage', { id: 10 })
            var footerData = res.data
        } else {
            var footerData = orginalJsonData.footer
        }
        this.floatInfo = footerData.floatInfo
    },
    mounted() {
        this.bindFlatBox()
    },
    beforeDestroy() {
        cancelAnimationFrame(this.animationId)
    },
    methods: {
        bindFlatBox() {
            var that = this
            const $box = $('#floatBox')
            const BOX_W = 81
            const BOX_H = 125

            let x = 50
            let y = 80
            let speedX = 0.5
            let speedY = 0.5
            let isPause = false
            let isOpen = false
            that.animationId = null

            // function move() {
            //     if (!isPause) {
            //         const winW = $(window).width()
            //         const winH = $(window).height()

            //         // 边界碰撞反弹
            //         if (x <= 0 || x + BOX_W >= winW) speedX = -speedX
            //         if (y <= 0 || y + BOX_H >= winH) speedY = -speedY

            //         x += speedX
            //         y += speedY

            //         $box.css({ left: x + 'px', top: y + 'px' })
            //     }
            //     that.animationId = requestAnimationFrame(move)
            // }

            // PC鼠标事件
            $box.on('mouseenter', function() {
                // isPause = true
                $('.float-menus').show()
            })
            $box.on('mouseleave', function() {
                // isPause = false
                $('.float-menus').hide()
            })
            // $box.find('.float-icon').on('click', function() {
            //     isOpen = !isOpen
            //     console.log(isOpen)
            //     if (isOpen) {
            //         isPause = true
            //         $('.float-menus').stop()
            //         $('.float-menus').fadeIn()
            //     } else {
            //         $('.float-menus').stop()
            //         $('.float-menus').fadeOut()
            //         isPause = false
            //     }
            // })

            // 移动端触摸
            $box.find(".float-icon").on('click', function(e) {
                e.preventDefault()
                if($(".float-menus").css("display") == 'none' ){
                    $('.float-menus').show()
                } else { 
                    $('.float-menus').hide()
                }
                // Toast("a")
            })
           
            // 启动动画
            // move()
        },
        toTel() {
            window.location.href = 'tel:' + this.floatInfo.tel.value
            $('.float-menus').hide()
        },
        toEmail() {
            window.location.href = 'mailto:' + this.floatInfo.email.value
            $('.float-menus').hide()
        },
        toMsg() {
            window.open('/index.php?s=index/join.html&nav=2')
            $('.float-menus').hide()
            // if(window.location.href.indexOf("index.html")>=0){ 
            //     var top = $('.page9').offset().top
            //     $('html,body').scrollTop(top - 100)
            // } else {
            //     window.location.href = '/index.php#page9'
            // }
        }
    }
}
</script>
<style scoped  lang="scss">
.float-icon-wrap {
    position: fixed;
    user-select: none;
    z-index: 200;
    width: 0.81rem;
    height: 1.25rem;
    right: 0.4rem;
    bottom: 1rem;
    @media screen and (max-width: 768px) {
        width: 0.75rem;
        height: 1.15rem;
    }
    // &:hover {
    //     .float-menus {
    //         display: block;
    //     }
    // }
    .float-icon {
        width: 0.81rem;
        height: 1.25rem;
        background: url(../assets/common/float-icon0.png) no-repeat center center;
        background-size: contain;
        z-index: 200;
        @media screen and (max-width: 768px) {
            width: 0.75rem;
            height: 1.15rem;
        }
    }
    .float-menus {
        width: 2.9rem;
        position: absolute;
        left: -3.2rem;
        top: -1.85rem;
        padding-right: 0.3rem;
        display: none;
        z-index: 200;

        @media screen and (max-width: 768px) {
            width: 2.7rem;
            left: -2.9rem;
            top: -0.75rem;
            padding-right: 0.2rem;
        }
        .items {
            background-color: #fff;
            padding: 0.1rem 0.1rem 0.1rem 0;
            box-shadow: 0 0 0.1rem rgba(0, 0, 0, 0.5);
            @media screen and (max-width: 768px) {
                padding: 0.1rem 0.1rem 0.1rem 0;
            }
            .item {
                width: 100%;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                justify-content: center;
                align-content: center;
                align-items: center;
                margin-bottom: 0.2rem;
                cursor: pointer;
                &:hover {
                    .info {
                        color: #e60012;
                    }
                }
                @media screen and (max-width: 768px) {
                    margin-bottom: 0.2rem;
                }
                &:last-child {
                    margin-bottom: 0;
                }
                &.tel .icon {
                    background: url(../assets/common/float-tel.png) no-repeat center center;
                    background-size: contain;
                }
                &.email .icon {
                    background: url(../assets/common/float-email.png) no-repeat center center;
                    background-size: contain;
                }
                &.msg .icon {
                    background: url(../assets/common/float-msg.png) no-repeat center center;
                    background-size: contain;
                }
                .icon {
                    width: 0.6rem;
                    height: 0.6rem;
                    @media screen and (max-width: 768px) {
                        width: 0.46rem;
                        height: 0.46rem;
                    }
                }
                .info {
                    width: 2.25rem;
                    line-height: 1.2;
                    color: #000;
                    @media screen and (max-width: 768px) {
                        width: 2.05rem;
                    }
                    .label {
                        font-size: 0.14rem;
                        @media screen and (max-width: 768px) {
                            font-size: 0.12rem;
                        }
                    }
                    .value {
                        font-size: 0.2rem;
                        @media screen and (max-width: 768px) {
                            font-size: 0.18rem;
                        }
                    }
                }
            }
        }
    }
}
</style>
